import { cva } from 'class-variance-authority';

export const triggerVariants = cva(
  [
    'box-border flex w-full flex-[1_1_auto] cursor-pointer items-center rounded-[5px] border border-transparent bg-[var(--color-form-field-bg,var(--color-surface-muted))] px-4 pr-[45px] text-left text-xs font-medium leading-3 text-[var(--color-form-field-text,var(--color-text-muted))]',
    'hover:shadow-[0_0_0_1px_var(--color-form-field-focus-ring,var(--color-nav-active-bg))] hover:outline-none',
    'focus:shadow-[0_0_0_1px_var(--color-form-field-focus-ring,var(--color-nav-active-bg))] focus:outline-none',
    'focus-visible:shadow-[0_0_0_2px_var(--color-form-field-focus-visible-ring)]',
    '[&[data-open=true][data-placement=bottom]]:rounded-b-none [&[data-open=true][data-placement=bottom]]:border-[var(--color-nav-active-bg)] [&[data-open=true][data-placement=bottom]]:border-b-border [&[data-open=true][data-placement=bottom]]:shadow-none [&[data-open=true][data-placement=bottom]]:outline-none',
    '[&[data-open=true][data-placement=top]]:rounded-t-none [&[data-open=true][data-placement=top]]:border-[var(--color-nav-active-bg)] [&[data-open=true][data-placement=top]]:border-t-border [&[data-open=true][data-placement=top]]:shadow-none [&[data-open=true][data-placement=top]]:outline-none',
  ],
  {
    variants: {
      size: {
        sm: 'h-8',
        md: 'h-10',
      },
      state: {
        default: '',
        error: [
          '!border-transparent !shadow-[0_0_0_1px_var(--color-form-field-error)] !outline-none focus-visible:!shadow-[0_0_0_2px_var(--color-form-field-error)]',
          '[&[data-open=true][data-placement=bottom]]:!border-[var(--color-form-field-error)] [&[data-open=true][data-placement=bottom]]:!border-b-border [&[data-open=true][data-placement=bottom]]:!shadow-none',
          '[&[data-open=true][data-placement=top]]:!border-[var(--color-form-field-error)] [&[data-open=true][data-placement=top]]:!border-t-border [&[data-open=true][data-placement=top]]:!shadow-none',
        ].join(' '),
        disabled:
          'pointer-events-none cursor-default !border-transparent !bg-[var(--color-form-field-disabled-bg,var(--color-surface-muted))] !text-[var(--color-form-field-disabled-text,var(--color-text-muted))] !opacity-100 !shadow-none !outline-none',
      },
    },
    defaultVariants: {
      size: 'md',
      state: 'default',
    },
  },
);
